import React from 'react'
import { Col, Button, Form, Modal } from 'react-bootstrap'

import { postContactDealer } from '../utils/rest'
import { regexEmail, states, fieldGroup } from '../components/Forms'
import './ContactDealerForm.css'
// post pretouch, saturday 
// strangely still works with data, best time and timeframe seem to be independent
// 2018-03- 04 left off saturday night, before going throug again - uses the data object rather than 'shoes'

// walk through purpose of all code
// do minor testing of each piece, small paws if necessary
// do we need all fields
// get it into the database
// how does error logging work
// set choices, set default values
// get into api mode - barack obama, change campaign ids
// clean up and document
// keep saving as we go
// check for goofy data sources
// apply to dealer application form

export default class ContactDealerForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      validationState: {},
       data: {
  		frFirstName: 'afirst',
		frLastName: 'alast',  
		frHomePhone: 'a1',   
		frMobilePhone: 'a1',   
		frWorkPhone: 'a1',   
		frAddress: 'a1',
		frCity: 'a1',
		frState: 'a1',
		frZip: 'a1',    
		frEMailAddress: 'a1',
				
		frWorkPhoneExt: 'a1',  
		frPhonePreference: 'a1',
		frPhoneTime: 'a1',
		frPurchaseTimeFrame: 'a1',
		frTradeIn: 'a1',
		frBudget: 'a1',
		frFinancing: 'a1'       		
  		},
      errors: [],
      delivered: false,
      enableSubmit: false,
                 	zzvalue: 'sss',
                 	yyvalue: 'rrr',

    }
  
    // populated during render()
    this.type = {}
    this.fieldGroup = fieldGroup.bind(this)

  }

  //---------------------
  //
  //---------------------
  componentDidMount = () => 
  {
    this.handleReset()
  }


  //---------------------
  //
  //---------------------
  handleReset = event => 
  {
  	

  //---------------------
  //  make a modal box, works within handlereset event
  // errors can be more complese
  //---------------------
/*	const errors = []

	console.error(`Contact Dealer Form: gloria`,  'hahaha')
	errors.push(new Error('Please fix form errors fool.'))
	this.setState(
		{
			errors,
		}
	)
	return; // needed to shoot an error
  	
*/  	
  	

  	  /*

    if (event) {
      //event.preventDefault()
    }

*/	

    let data = {}

    const validationState = {}

    Object.keys(this.type).forEach(name => 
    {
      data[name] = ''
      validationState[name] = null
    })


    data = { ...data, ...(this.props.data ? this.props.data : {}) }

    // assume all default data is valid
	
    if (this.props.data) {
      Object(this.props.data)
        .keys()
        .forEach(name => {
          validationState[name] = 'success'
        })
    }
    this.setState({
      data, // setting data here wipes out all the data from initial values
      validationState,
      errors: [],
      enableSubmit: this.hasMinimalData(data),
    })

  }// end reset

  
   //---------------------
  //
  //---------------------
handleChange = event => {


//let rdata = this.state.data

    event.preventDefault()
    let { name, value } = event.target

    if (name.match(/PhoneExt/) && !value.match(/^[\d]*$/)) {
      return
    }
    if (name.match(/(Home|Work|Mobile)Phone/) && !value.match(/^[ \d()x-]*$/)) {
      return
    }
    if (name === 'frZip' && !value.match(/^(|[0-9]{5}$)/)) {
      return
    }
    const data = {
      ...this.state.data,
      [name]: value,
    }
    this.setState({
      data,
//PUT THIS BACK      enableSubmit: this.hasMinimalData(data),
     enableSubmit: true,

     
    })
  }

  hasMinimalData = (data = this.state.data) => {
    return !!(
      data.frFirstName &&
      data.frLastName &&
      (data.frHomePhone ||
        data.frMobilePhone ||
        data.frWorkPhone ||
        (data.frAddress && data.frCity && data.frState && data.frZip) ||
        data.frEMailAddress)
    )
  }

  handleSubmit = event => {
    event.preventDefault()
    const errors = []
    let valid = true
    let validationState = []
    const data = {}
    if (!this.hasMinimalData()) {
      valid = false
      errors.push = new Error(
        'Please fill out your name and at least one method of contact (email, phone or address)'
      )
    }

    Object.keys(this.state.data).forEach(name => {
      const type = this.type[name]
      let value = this.state.data[name]

      data[name] = typeof value === 'undefined' ? undefined : value.trim()
      if (type !== 'select') {
        validationState[name] = typeof value === 'undefined' ? null : 'success'

        switch (this.type[name]) {
          case 'email':
            if (value && !value.match(regexEmail)) {
              validationState[name] = 'error'
              valid = false
            }
            break
          case 'tel':
            value = value.replace(/[^0-9]/g, '')
            if (value.length && value.length !== 10) {
              validationState[name] = 'error'
              valid = false
            }
            data[name] = value
            break
          case 'number':
            if (!value.match(/^\d*$/)) {
              validationState[name] = 'error'
              valid = false
            }
            break
          default:
            break
        }
      }

      if (name === 'frZip' && !value.match(/^\d{5}$/)) {
        validationState[name] = 'error'
        valid = false
      }
    })

    if (valid) {
      postContactDealer(this.props.vin, this.state.data)
        .then(delivered => this.setState({ delivered }))
        .catch(err => {
          this.setState({
            errors: [
              'The server could not process your request at this time. Please try again later.',
            ],
          })
          console.error(
            `Contact Dealer Form: ${err}: ${this.props.vin}`,
            this.state.data
          )
        })
    } else {
      errors.push(new Error('Please fix form errors.'))
    }

    this.setState({
      validationState,
      enableSubmit: this.hasMinimalData(),
      errors,
    })
  }

  render = () => {
    const FieldGroup = this.fieldGroup

    return this.state.delivered ? (
      <div id="ContactDealerForm">
        <p class="response">{this.state.delivered.message}</p>
      </div>
    ) : (
      <Form
        id="ContactDealerForm"
        onSubmit={this.handleSubmit}
        onReset={this.handleReset}
        onChange={this.handleChange}
      >
        <Modal
          className="error-modal"
          show={this.state.errors.length > 0}
          onHide={_ => this.setState({ errors: [] })}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            {this.state.errors.map((error, i) => (
              <p key={i} className="error">{`${error}`}</p>
            ))}
          </Modal.Body>
        </Modal>
        <FieldGroup
          id="frFirstName"
          label="First Name"
          maxLength="20"
          required
        />
        <FieldGroup id="frLastName" label="Last Name" maxLength="20" required />
        <FieldGroup id="frAddress" label="Address" maxLength="30" />
        <FieldGroup id="frCity" label="City" maxLength="20" />
        <FieldGroup id="frState" label="State" type="select"  value={this.state.data.frState}  onChange={this.handleChange}>
        
          {['', ...states].map(state => (
            <option value={state} key={state}>
              {state}
            </option>
          ))}
        </FieldGroup>
        <FieldGroup id="frZip" label="Zip Code" type="number" maxLength="5" />
        <FieldGroup
          id="frHomePhone"
          label="Home Phone"
          type="tel"
          maxLength="20"
        />
        <FieldGroup
          id="frMobilePhone"
          label="Mobile Phone"
          type="tel"
          maxLength="20"
        />
        <FieldGroup
          id="frWorkPhone"
          label="Work Phone"
          type="tel"
          maxLength="20"
        />
        <FieldGroup
          id="frWorkPhoneExt"
          label="Ext."
          type="number"
          maxLength="10"
        />
        <FieldGroup
          id="frPhonePreference"
          label="Preferred Phone"
          type="select"
           value={this.state.data.frPhonePreference}  onChange={this.handleChange}
        >
          <option value="Any">Any</option>
          <option value="Home">Home</option>
          <option value="Mobile">Mobile</option>
          <option value="Work">Work</option>
        </FieldGroup>
        <FieldGroup
          id="frPhoneTime"
          label="Best Time to Call"
          type="select"
           value={this.state.data.frPhoneTime}  onChange={this.handleChange}
        >
          <option value="Any">Any</option>
          <option value="Morning">Morning</option>
          <option value="Afternoon">Afternoon</option>
          <option value="Evening">Evening</option>
          <option value="Night">Night</option>
        </FieldGroup>
        <FieldGroup
          id="frEMailAddress"
          label="Email"
          type="email"
          maxLength="30"
        />
        <FieldGroup
          id="frPurchaseTimeFrame"
          label="Time frame"
          type="select"
          
           value={this.state.data.frPurchaseTimeFrame}  onChange={this.handleChange}
        >
          <option value="ASAP">As soon as possible</option>
          <option value="1 to 3 weeks">1 to 3 weeks</option>
          <option value="4 weeks or more">4 weeks or more</option>
        </FieldGroup>
        <FieldGroup id="frTradeIn" label="Trade-in" maxLength="2000" />
        <FieldGroup
          id="frFinancing"
          label="Financing"
          type="select"
          value="Cash"
        >
          <option>Cash</option>
          <option>Finance</option>
          <option>Lease</option>
        </FieldGroup>
        <FieldGroup id="frBudget" label="Budget" type="select" value="2000">
          <option value="2000">$2,000</option>
          <option value="3000">$3,000</option>
          <option value="4000">$4,000</option>
          <option value="5000">$5,000</option>
          <option value="6000">$6,000</option>
          <option value="7000">$7,000</option>
          <option value="8000">$8,000</option>
          <option value="9000">$9,000</option>
          <option value="10000">$10,000</option>
          <option value="11000">$11,000</option>
          <option value="12000">$12,000</option>
          <option value="13000">$13,000</option>
          <option value="14000">$14,000</option>
          <option value="15000">$15,000</option>
          <option value="17500">$17,500</option>
          <option value="20000">$20,000</option>
          <option value="22500">$22,500</option>
          <option value="25000">$25,000</option>
          <option value="27500">$27,500</option>
          <option value="30000">$30,000</option>
          <option value="35000">$35,000</option>
          <option value="40000">$40,000</option>
          <option value="45000">$45,000</option>
          <option value="50000">$50,000</option>
          <option value="60000">$60,000</option>
          <option value="70000">$70,000</option>
          <option value="80000">$80,000</option>
          <option value="90000">$90,000</option>
        </FieldGroup>
        <Col xs={9} xsOffset={3}>
          <Button
            type="submit"
            title={
              this.state.enableSubmit
                ? 'Send your contact information to the dealer'
                : 'Please fill in your name plus one form of contact (phone, mailing address, or email)'
            }
            disabled={!this.state.enableSubmit}
          >
            Request Quote
          </Button>{' '}
          <Button type="reset" title="Clear the form">
            Reset Form
          </Button>
        </Col>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactDealerForm.js